/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from '../../common/constants';
import { SIDEBAR_WIDTH } from './constants';
export var PageContent = function PageContent() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(Image, null)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  position: 'fixed',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  top: "".concat(HEADER_HEIGHT + 150, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  left: "".concat(SECONDARY_NAV_WIDTH + 24, "px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  right: "".concat(SIDEBAR_WIDTH + 24, "px"),
  minHeight: '661px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ImageWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center'
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "820",
    height: "619",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2D4FF",
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065FF",
    d: "M24.466 25.316ZM17.472 30.51l.026-.105.023-.095-1.26.653 1.308-.87c.018-.098.029-.195.026-.29a.653.653 0 0 0-.059-.256c-.115-.038-.202-.168-.205-.33-.002-.197.118-.358.267-.363.084 0 .156.046.207.123.223.148.343.435.374.711l3.67-2.442c1.862-.822 2.445-1.505 2.607-1.935h.005-.005c.117-.31.018-.487.018-.487-.136-1.2-.799-1.85-1.587-2.191-1.01.602-2.494 1.093-3.07.632l.036.497c.015.023.054.066.105.12l.025.028c.07.075.151.167.22.251.09.113.152.215.113.256-.171.085-.343.18-.512.287-1.664 1.03-3.228 2.908-3.725 3.558-.028-.02-.069-.053-.12-.094-.576-.74-2.13-2.563-3.76-3.53a5.293 5.293 0 0 0-.62-.32c-.008-.013-.013-.026-.02-.039a.234.234 0 0 1 .074-.077c.002 0 .005-.005.01-.007l.059-.039c.15-.084.358-.15.407-.228l.118-1.54s-.008 0-.02-.006c-.006.264-.024.556-.057.873-.566.476-2.056-.015-3.072-.617-.78.343-1.439.988-1.572 2.184 0 0-.102.179.02.491-1.251.4-2.521.873-3.417 1.38a15.954 15.954 0 0 0 10.056 5.192c-.029-.482-.093-.906-.203-1.226l-.035-.1c-.085-.236-.18-.502-.17-.791 0-.029.006-.057.01-.085L6.355 25.87c.397-.151.812-.295 1.229-.433.228.43.865 1.063 2.547 1.805l3.679 2.253c.056-.17.156-.328.297-.448a.387.387 0 0 1 .358-.213c.213.005.379.167.374.364-.005.197-.18.353-.392.348h-.008a.426.426 0 0 0-.092.243v.036l1.452.888s.005.013.01.02l-1.441-.739c.025.118.066.238.112.366l.039.105c.138.4.215.911.24 1.475.41.03.825.053 1.245.053.468 0 .931-.025 1.39-.064-.031-.555-.01-1.052.082-1.426l-.003.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065FF",
    d: "M18.181 29.97c-.015.205-.064.397-.11.581l-.026.102c-.076.313-.094.738-.069 1.222a15.969 15.969 0 0 0 9.92-5.177 13.857 13.857 0 0 0-1.815-.822l-7.897 4.094h-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#PageContentB)",
    d: "M20.2 24.164c-.068-.085-.15-.174-.22-.251a.155.155 0 0 1-.015-.013c-.002 0-.007-.01-.01-.013a1.6 1.6 0 0 1-.105-.12l-.036-.497-.012-.007a12.55 12.55 0 0 1-.057-.817c-.005-.033-.005-.064-.008-.092-.04-.522-.076-1.1-.104-1.626-.59.569-1.411 1.13-2.57 1.582a2.062 2.062 0 0 1-.748.154h-1.08c-.262 0-.512-.061-.748-.154-.952-.37-1.677-.816-2.232-1.28-.013.382-.031.781-.052 1.16V22.39c.013 0-.094 1.543-.094 1.543-.049.077-.256.144-.407.228l-.06.039c-.002 0-.004.005-.01.007a.263.263 0 0 0-.074.077c.008.013.013.026.02.039.208.092.413.2.62.32 1.631.967 3.185 2.787 3.761 3.53l.12.095c.497-.653 2.061-2.53 3.725-3.559.17-.105.34-.2.512-.287.039-.04-.023-.14-.113-.256l-.002-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0747A6",
    d: "M14.48 30.367a2.964 2.964 0 0 1-.113-.366l1.441.74-.01-.021-1.452-.888v-.036a.42.42 0 0 1 .092-.243h.008c.213.005.387-.151.392-.349.005-.197-.164-.358-.374-.363a.387.387 0 0 0-.358.212.962.962 0 0 0-.297.448L10.13 27.25c-1.682-.743-2.32-1.372-2.547-1.805-.417.138-.832.281-1.229.433l7.414 3.814c-.003.028-.008.056-.01.084-.01.29.084.556.169.791l.035.1c.11.318.177.745.203 1.226.197.024.396.041.596.057-.026-.566-.102-1.075-.24-1.475l-.039-.105-.003-.002ZM18.045 30.653l.026-.102c.049-.187.095-.379.11-.581l7.898-4.093c-.52-.2-1.068-.387-1.61-.561h-.011c-.164.43-.745 1.113-2.606 1.935l-3.67 2.442c-.029-.279-.152-.563-.375-.711-.05-.075-.125-.126-.207-.123-.151.005-.271.166-.266.363.002.164.09.292.205.33.03.062.056.15.058.257 0 .094-.007.19-.025.289l-1.308.87 1.26-.652c-.009.03-.016.06-.024.094l-.025.105c-.093.374-.113.868-.082 1.426.197-.018.391-.038.586-.061-.023-.482-.008-.91.069-1.221l-.003-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172B4D",
    d: "M12.145 23.26c.036-.317.05-.61.056-.873V22.188c.02-.38.038-.779.051-1.16-1.779-1.485-1.797-3.149-1.797-3.149-.008-.08-.015-.154-.02-.23h-.082c-.5-2.128-.855-3.91-.031-3.828a.81.81 0 0 1 .24.062c.034-.036.267-.512.423-.812a.684.684 0 0 1 .39-.338c.836-.286 1.453-.15 1.453-.15.044-.2.103-.387.172-.564.156-.32.396-.763.722-1.18a4.685 4.685 0 0 1 1.51-1.131c.077-.021.156-.036.236-.047 1.812.067 4.669 2.517 5.273 4.053.123.31.305.261.484.125.171-.13.335-.343.433-.391.035.023.074.046.105.074.34.673.291 1.564.048 2.57-.051.18-.1.34-.146.474-.21.601-.302.937-.55 1.042a9.71 9.71 0 0 1-.026.274s-.015 1.449-1.459 2.849a69.25 69.25 0 0 0 .113 1.718 12.744 12.744 0 0 0 .056.817l.013.007c.576.463 2.06-.03 3.07-.632.647-.387 1.1-.814.987-1.065a2.796 2.796 0 0 1-.166-.52c-.03-.535-.064-1.093-.102-1.664.025-1.556.156-3.63-.745-6.438-.057-.295-.113-.592-.177-.884-.274-1.236-.793-2.516-1.602-3.591a6.662 6.662 0 0 0-5.464-2.852c-2.82 0-5.232 1.759-6.215 4.247a9.924 9.924 0 0 0-.755 2.196c-.228 1.027-.3 2.084-.308 3.141-.53 3.037.32 5.051-.268 6.367-.113.251.345.684 1 1.07 1.017.602 2.504 1.093 3.073.617l.005-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A96935",
    d: "M21.12 17.603c.248-.108.34-.443.55-1.042.047-.13.098-.295.146-.474.244-1.006.292-1.897-.048-2.57a.512.512 0 0 0-.105-.074c-.097.048-.261.26-.433.391.023.305.036.615.036.924 0 1.05-.059 1.905-.146 2.845ZM10.325 13.816c-.822-.08-.469 1.7.03 3.827.026.003.054 0 .082 0a30.21 30.21 0 0 1-.148-2.89c0-.317.013-.632.036-.942v.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4743D",
    d: "M15.237 22.461h1.08c.262 0 .512-.061.748-.153 1.157-.45 1.982-1.011 2.57-1.582 1.447-1.398 1.46-2.85 1.46-2.85.007-.092.017-.184.025-.273.087-.943.146-1.795.146-2.845 0-.312-.013-.62-.036-.924-.177.136-.36.185-.484-.125-.604-1.539-3.463-3.989-5.273-4.053-.08.01-.159.026-.236.046-.26.12-.93.469-1.51 1.132-.323.417-.566.86-.722 1.18-.07.177-.126.364-.172.563 0 0-.617-.135-1.454.151a.684.684 0 0 0-.389.338c-.156.3-.392.776-.422.812a.921.921 0 0 0-.24-.062c-.024.31-.037.625-.037.942 0 1.068.062 1.93.149 2.89l.02.231s.016 1.667 1.797 3.149c.556.463 1.28.909 2.233 1.28.235.092.489.153.747.153Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "160",
    height: "32",
    x: "40",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "120",
    height: "6",
    x: "48",
    y: "13",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M171 4h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M179.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "208",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M212 4h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M223.793 9.793a.993.993 0 0 0-.217 1.09c.05.121.124.231.217.324L227.586 15H218a1 1 0 1 0 0 2h9.586l-3.793 3.793a.994.994 0 0 0-.217 1.09 1.002 1.002 0 0 0 1.632.324l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.995.995 0 0 0-.293-.678l-5.499-5.5a.997.997 0 0 0-1.09-.217.997.997 0 0 0-.325.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "32",
    x: "248",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "60",
    height: "6",
    x: "256",
    y: "13",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M319 4h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M327.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "99",
    height: "32",
    x: "720",
    fill: "#B3D4FF",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "59",
    height: "6",
    x: "728",
    y: "13",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M790 4h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".25",
    fillRule: "evenodd",
    d: "M798.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "52",
    height: "14",
    x: "40",
    y: "44",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "44",
    height: "6",
    x: "44",
    y: "48",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "206",
    height: "6",
    x: "108",
    y: "48",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "53",
    height: "6",
    y: "90",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M0 106h77v2H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "53",
    height: "6",
    x: "77",
    y: "90",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M77 106h77v2H77z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "53",
    height: "6",
    x: "154",
    y: "90",
    fill: "#4C9AFF",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C9AFF",
    d: "M154 106h77v2h-77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M231 106h589v2H231z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "160",
    height: "32",
    y: "132",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "120",
    height: "6",
    x: "8",
    y: "145",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M131 136h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M139.292 146.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    d: "M268 230h62v389h-62z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "250",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "250",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "272",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "294",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "294",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "316",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "316",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "295",
    y: "344",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3",
    transform: "rotate(-180 295 344)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "360",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "360",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "456",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "456",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "280",
    y: "500",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "6",
    x: "303",
    y: "500",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    d: "M268 188h551v42H268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M280 197h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M288.292 207.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "89.122",
    height: "6",
    x: "312",
    y: "206",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "10",
    x: "676",
    y: "204",
    stroke: "#091E42",
    strokeOpacity: ".13",
    strokeWidth: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "6",
    x: "695",
    y: "206",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M751 197h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M765 201.187a10.734 10.734 0 0 0-2-.187c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.031.164.033a.52.52 0 0 0 .429-.231.516.516 0 0 0 .045-.485v-.002s-1.563-2.26-.766-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-.171-.006-.342-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229v-2.045Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M770 202a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    d: "M771 203h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M783 197h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M795 211a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122A1.503 1.503 0 0 1 795 211Zm-4.5 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Zm9 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M338 228h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "350",
    cy: "240",
    r: "2",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "75",
    height: "6",
    x: "370",
    y: "237",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3FCEF",
    d: "M330 250h489v20H330z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M344 254h12v12h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M350.5 259.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "370",
    y: "257",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M338 288h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "350",
    cy: "300",
    r: "2",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "209",
    height: "6",
    x: "370",
    y: "297",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M338 308h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "350",
    cy: "320",
    r: "2",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "135",
    height: "6",
    x: "370",
    y: "317",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBE6",
    d: "M330 330h489v20H330z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "2",
    x: "347",
    y: "339",
    fill: "#D9D9D9",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "83",
    height: "6",
    x: "370",
    y: "337",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3FCEF",
    d: "M330 350h489v100H330z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M344 354h12v12h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M350.5 359.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "370",
    y: "357",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M344 374h465v68H344z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0B6F2",
    d: "M375.904 393.998c0-6.574-5.33-11.904-11.904-11.904s-11.904 5.33-11.904 11.904 5.33 11.904 11.904 11.904 11.904-5.33 11.904-11.904Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#998DD9",
    d: "M369.098 403.32a3.41 3.41 0 0 1-2.116-3.151 3.324 3.324 0 0 1 1.171-2.565c4.694-3.942 1.782-11.574-4.276-11.453-5.935.102-8.634 7.592-4.03 11.453a3.324 3.324 0 0 1 1.171 2.565 3.408 3.408 0 0 1-2.116 3.151c-.368.153-.731.322-1.088.505-.098.051-.194.109-.292.165a11.85 11.85 0 0 0 6.476 1.918c2.391 0 4.616-.709 6.482-1.922a15.005 15.005 0 0 0-.518-.271 12.696 12.696 0 0 0-.866-.393l.002-.002Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "119",
    height: "6",
    x: "388",
    y: "391",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "303.948",
    height: "6",
    x: "352",
    y: "414",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "191.135",
    height: "6",
    x: "352",
    y: "428",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M338 448h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "350",
    cy: "460",
    r: "2",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "135",
    height: "6",
    x: "370",
    y: "457",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageContentI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M338 488h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "350",
    cy: "500",
    r: "2",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "105",
    height: "6",
    x: "370",
    y: "497",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#091E42",
    strokeOpacity: ".13",
    d: "M268.5 188.5h550v430h-550z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "80",
    height: "32",
    x: "739",
    y: "132",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "64",
    height: "6",
    x: "747",
    y: "145",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M16 196h24v24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M24.292 206.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "56",
    y: "205",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M32 236h24v24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M40.292 246.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "72",
    y: "245",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "184",
    height: "20",
    x: "48",
    y: "278",
    fill: "#091E42",
    fillOpacity: ".04",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "79",
    height: "6",
    x: "80",
    y: "285",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M46 276h24v24H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M54.292 286.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M16 316h24v24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M24.292 326.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "56",
    y: "325",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M32 356h24v24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M40.292 366.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "72",
    y: "365",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M16 396h24v24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M24.292 406.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "56",
    y: "405",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M32 436h24v24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M40.292 446.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "72",
    y: "445",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M32 476h24v24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091E42",
    fillOpacity: ".13",
    fillRule: "evenodd",
    d: "M40.292 486.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "131",
    height: "6",
    x: "72",
    y: "485",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#091E42",
    strokeOpacity: ".13",
    d: "M.5 188.5h239v430H.5z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268 188h551v431H268z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentD"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330 230h489v20H330z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentE"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330 290h489v20H330z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330 310h489v20H330z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentG"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M352 382h24v24h-24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentH"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330 450h489v20H330z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageContentI"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330 490h489v20H330z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PageContentB",
    x1: "15.944",
    x2: "15.944",
    y1: "35.84",
    y2: "20.992",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4743D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".43",
    stopColor: "#BB703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#A96935"
  }))));
};